var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"link",on:{"click":function($event){return _vm.$emit('action', {action: _vm.columnData.action, rowId: _vm.rowId})}}},[_vm._v(_vm._s(_vm.columnData.caption))])])
}
var staticRenderFns = []

export { render, staticRenderFns }